import { useRouter } from 'next/router';
import { useState, useEffect } from 'react';

export default function useLoadingState(): { loading: boolean } {
  const router = useRouter();
  const [loading, setLoading] = useState(false);
  useEffect(() => {
    const start = (): void => {
      setLoading(true);
    };
    const end = (): void => {
      setLoading(false);
    };
    router.events.on('routeChangeStart', start);
    router.events.on('routeChangeComplete', end);
    router.events.on('routeChangeError', end);
    return (): void => {
      router.events.off('routeChangeStart', start);
      router.events.off('routeChangeComplete', end);
      router.events.off('routeChangeError', end);
    };
  }, [router.events]);

  return { loading };
}
